import _ from "lodash";
import ExternalLogger from "core-ui/client/src/app/ExternalLogger";
import registrationEvents from "./events/RegistrationEvents";
import ErrorViewTemplate from "../error/ErrorViewTemplate";

var registrationSummaryController = function (
    $injector,
    $modal,
    $q,
    $rootScope,
    $scope,
    $state,
    $timeout,
    $translate,
    EDeliveryService,
    dataService,
    deepLinkFactory,
    eventBus,
    beneficiaryTypeService,
    beneficiaryService,
    redirectService,
    registrationFactory,
    TransactionAccessRetrService
) {
    const logger = ExternalLogger.getInstance("RegistrationSummaryController");
    var vm = this;
    vm.summary = null;
    vm.beneficiaries = null;
    vm.beneficiariesTypes = null;
    vm.model = null;
    vm.isDataLoaded = false;

    vm.allowEDelivery = false;

    vm.translate = {
        eDeliveryError: $translate.instant("preference.eDelivery.errorMessage")
    };

    function retriveRegistrationSummaryData() {
        registrationFactory.registrationSummary.query(
            function (data) {
                if (data !== null) {
                    vm.summary = data;
                    vm.groupedInvestmentOptions = !_.isEmpty(vm.summary.investmentOptions)
                        ? _.groupBy(vm.summary.investmentOptions, "groupingCode")
                        : null;
                    vm.groupingCodes = Object.keys(vm.groupedInvestmentOptions).length;
                }
            },
            function () {
                logger.error("retrive registration summary data  failed");
            }
        );
    }

    $scope.init = function () {
        var deferred = $q.defer();
        var primaryPlanService = $injector.get("primaryPlanService");
        // String to pass to EventBus.Dispatch on registration success
        var PPGASTRING = "Primary Plan Success Info";
        setTimeout(function () {
            primaryPlanService
                .getPrimaryPlan()
                .then(onGetPrimaryPlanSuccess, onGetPrimaryPlanFailure);
        }, 10);

        function onGetPrimaryPlanSuccess(plan) {
            if (plan.indId && plan.gaId && plan.indId !== undefined && plan.gaId !== undefined) {
                retriveRegistrationSummaryData();

                //ONLY fetch benens if benes are enabled
                var txnCodeParams = {
                    txnCode: "WNBEN",
                    individualId: plan.indId,
                    groupId: plan.gaId
                };

                if ($rootScope.featureName !== undefined) {
                    $rootScope.deeplinkCust.gaId = plan.gaId;
                }

                //send planId and individualID to analytics on get Primary plan success
                eventBus.dispatch(PPGASTRING, this, {
                    gaId: plan.gaId,
                    indId: plan.indId
                });

                TransactionAccessRetrService.queryWithAccount(
                    txnCodeParams,
                    function (response) {
                        if (response && response.WNBEN && response.WNBEN !== "false") {
                            dataService.getBeneficiaries(plan.gaId).then(function (beneficiaries) {
                                vm.beneficiaries = beneficiaries;
                                vm.beneficiaries.qjsaVerificationRequired = false;
                            });
                            dataService.getBeneficiaryTypes(plan.gaId).then(function (beneTypes) {
                                vm.beneficiariesTypes = beneTypes;
                                beneficiaryTypeService.setTypes(vm.beneficiariesTypes);
                            });
                        }
                    },
                    function (err) {
                        //Error with transaction access call
                        logger.error("transaction authoriziation retrieval error", err);
                    }
                );

                EDeliveryService.initialize(plan.gaId).then(function (allowEDelivery) {
                    vm.allowEDelivery = allowEDelivery && plan.statusCode == "A";
                });
            }

            deferred.resolve();
        }

        function onGetPrimaryPlanFailure(err) {
            deferred.reject(err);
        }

        return deferred.promise;
    };

    /*to get the bene types*/
    $scope.getTypeOrRelationshipDisplay = function (beneficiaries) {
        return beneficiaryService.getTypeOrRelationshipDisplay(
            beneficiaries,
            beneficiaryTypeService.getTypes()
        );
    };

    /**
     * When the "Continue to My Account" link is clicked, we need to submit the e-delivery preference before moving
     * on to My Account.
     *
     * @param {Object} $event The click event that triggered this function
     */
    vm.submitEDelivery = function ($event) {
        if (!EDeliveryService.validateForm()) {
            if ($event.currentTarget && $event.currentTarget.id) {
                // Reset the loading button
                $scope.$broadcast("reset-loading-button-" + $event.currentTarget.id);
            }

            return;
        }

        EDeliveryService.updateParticipantEConsent("registrationFlow").then(function (success) {
            if (success) {
                vm.continueToMyAccount();
            } else {
                // There was a problem saving the communication preference. Display an modal dialog and continue
                // with navigation when it is dismissed.
                var modal = $modal.open({
                    template: ErrorViewTemplate,
                    size: "md",
                    resolve: {
                        errorMessage: function () {
                            return vm.translate.eDeliveryError;
                        }
                    },
                    controller: [
                        "$scope",
                        "errorMessage",
                        function ($scope, errorMessage) {
                            $scope.errorMessage = errorMessage;
                        }
                    ]
                });

                modal.result.then(function () {
                    vm.continueToMyAccount();
                });
            }
        });
    };

    /**
     * Complete the "Continue to My Account" workflow after the [optional] e-delivery preference has been updated.
     */
    vm.continueToMyAccount = function () {
        if ($rootScope.regData !== undefined && $rootScope.regData !== null) {
            $rootScope.regData.destinationUrl = $rootScope.regData.postRegSummaryUrl;
        }
        // set flag for deeplink featureName
        // if this flag is true than redirect to deeplink
        if ($rootScope.featureName !== undefined) {
            const handleError = () => {
                redirectService.redirect({
                    destinationUrl: "participant/accounts/#/",
                    flowName: "deepLink"
                });
            };
            var jsonPostForDest = {
                authTxnCodes: $rootScope.deeplinkCust.authTxnCodes,
                deepLinkedUrl: $rootScope.deeplinkCust.url,
                gaID: $rootScope.deeplinkCust.gaId,
                targetTxnCode: $rootScope.deeplinkCust.menuAccessCode
            };

            deepLinkFactory.getDestination.query(
                jsonPostForDest,
                function (data) {
                    if (data.deepLinkEligible) {
                        redirectService.redirect(data, "ALL", "RegistrationSummary");
                    } else {
                        handleError();
                    }
                },
                function () {
                    handleError();
                }
            );
        } else {
            registrationFactory.registrationflowAndDestination.query(
                function (data) {
                    if (data !== null) {
                        redirectService.redirect(data, "ALL", "RegistrationSummary");
                    }
                },
                function (response) {
                    if (response.headers("exception") !== null) {
                        $scope.registrationSummaryMessage = response.data.error.code;
                        $scope.registrationSummaryMessageParams = response.data.error.errors[0];
                    }
                }
            );
        }
    };

    function onInitSuccess() {
        vm.isDataLoaded = true;
    }

    function onInitFailure() {
        // TODO: Refactor this to use logger
        console.error(" registration summary initiation failed !  ");

        vm.isDataLoaded = true;
    }

    $scope.init().then(onInitSuccess, onInitFailure);

    //----EVENTS------
    $scope.printClick = function () {
        eventBus.dispatch(registrationEvents.PRINT, this);
    };
    $scope.otherContribToggle = function (val) {
        eventBus.dispatch(registrationEvents.OTHER_CONTRIB_TOGGLE, this, {
            value: val
        });
    };

    $scope.agreeClick = function () {
        eventBus.dispatch(registrationEvents.AGREE, this);
    };
};

registrationSummaryController.$inject = [
    "$injector",
    "$modal",
    "$q",
    "$rootScope",
    "$scope",
    "$state",
    "$timeout",
    "$translate",
    "EDeliveryService",
    "dataService",
    "deepLinkFactory",
    "eventBus",
    "beneficiaryTypeService",
    "beneficiaryService",
    "redirectService",
    "registrationFactory",
    "TransactionAccessRetrService"
];
export default registrationSummaryController;
